// images @ ui/src/components/static/
// files @ ui/public/

import React, { Component } from 'react'
import './home.css'

function importAll(r) {
  let images = {};
  r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
  return images;
}
const images = importAll(require.context('./static', false));
//console.log('images:', images)


class HomeEN extends Component {
  constructor(props) {
    super(props)
    this.topFunction = this.topFunction.bind(this);
  }

  topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  render() {
    //console.log('images: ', images)
    return (
      <section className="mx-5" style={{ maxWidth: "100%" }} >
        <p id="FSV Usage" className="line-spacing" style={{fontSize: "24px", color: 'red', textAlign: 'center'}}>FiveStar Vocabulary Builder</p>
        <p className="line-spacing" style={{textAlign: 'center'}}> <b>U</b>nderstand <b>D</b>eeper, <b>R</b>emember <b>L</b>onger, <b>R</b>ecall <b>E</b>asier</p>
        <hr style={{   background: 'lime',   color: 'lime',   borderColor: 'lime',   height: '1px', }}       />

        <p style={{ color: 'blue' }}> FiveStar Vocab and SpellingBee are functionally complementary word games designed for you to quickly master deep vocabulary. While FiveStar Vocab builds connections between images, five components and words to enhance deeper understanding, SpellingBee focuses on listening comprehension & word spelling.</p>
        <br></br>

        <p id="FSV ref" className="title is-6">1. Deep and Shallow Vocabulary in the AI Era</p> 
        <p>"Deep Vocabulary: The Skill AI Makes More Valuable, Not Less" — Cal Newport</p>
        <img src={images['Cal-Newport-small.png']} width="459" height="222" alt="Cal Newport" 
          style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
        <br></br>

        <p>The demo video shows the different results of learning deep and shallow vocabulary in an analogical way (source: 长沙一家人"捡瓶子比赛").</p>
        <br></br>
        <video width="263" height="394" controls >
        <source src="./videos/bottle-collect-demo-1min.mp4" type="video/mp4"/>
        </video>
        <br></br> <br></br><br></br>

        <p><b>2. FiveStar Vocab [1] </b>is a new word guessing game to maximize deep understanding through a path of least-resistance, in which each word is broken down into five connected components. </p>
        <br></br>
        <p>The featured COEI segment (Characteristics or Essential Information) helps learners achieve deep comprehension. By creating a 'scaffolded' learning path [2], it empowers learners to successfully recall words even after long intervals.</p>
        <img src={images['five-star-word-w-5com.png']} width="285" height="196" alt="five-star-figure" 
          style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
        <br></br>

        <p id="FSV ref" className="title is-6">3. The Learning Resources for the FiveStar Vocabulary Builder</p>
        <p>1) Video links: </p>
        <p>
          <a href="https://www.youtube.com/@FiveStarVocab" target="_blank" rel="noopener noreferrer"> <u>https://www.youtube.com/@FiveStarVocab</u>
          </a>
        </p>
        <p>
          <a href="https://space.bilibili.com/3546872866146315" target="_blank" rel="noopener noreferrer"> <u>https://space.bilibili.com/3546872866146315  (中国大陆)</u>
          </a>
        </p>

        {/* <p>
          <a href="https://www.bilibili.tv/en/space/1430633718 " target="_blank" rel="noopener noreferrer"> <u>https://www.bilibili.tv/en/space/1430633718 (South Asia)</u>
          </a>
        </p> */}
        <br></br>

        <p>2) Free booklet download:
          <a href="./books/book2.pdf" target="_blank" rel="noopener noreferrer"> <u>"FiveStar Vocabulary Builder – Mobile Edition"</u>
          </a>        
        </p>
        <p>To check the published and upcoming books, please tap here for 
          <a href="./books.txt" target="_blank"><u> books</u></a>
        </p>
        <br></br>

        <p>3) Customized Services and Contacts</p>
        <p>If you have a specialized vocabulary list or any other language you wish to adapt into the FiveStar Vocab
        style book, or you would like to order the upcoming books, please click "Email Contact" at the bottom of this page.</p>
        <br></br>

        <p id="FSV ref" className="title is-6">4. Key References</p> 
        <p>[1] 
          <a href="./books/book2.pdf" target="_blank" rel="noopener noreferrer"> <u>FiveStar Vocabulary Builder – Mobile Edition</u>
          </a>
        </p>
        <p>[2] Lev Vygotsky, Zone of Proximal Development (ZPD) and Scaffolding, 1930s</p>
        <p>[3] Nation, I. S. P., Learning Vocabulary in Another Language, Cambridge University Press, 2013</p>
        <p>[4] Bjork, E. L., & Bjork, R. A., Introducing desirable difficulties into practice and instruction: Obstacles and opportunities, 2023
        </p>
        <br></br>

      </section>
    )
  }
}

export default HomeEN